import { MapPin, Building, FileText, Shield, ExternalLink } from 'lucide-react';
import PublicShell from '@/components/layouts/PublicShell';

const BAFIN_REGISTER_URL = 'https://portal.mvp.bafin.de/database/InstInfo/institutDetails.do?cmd=loadInstitutAction&institutId=155391';

const ImpressumPage = () => {
  return (
    <PublicShell>
      {/* Hero */}
      <div className="relative bg-primary-950 overflow-hidden">
        <img src="/images/sv-office-building.jpg" alt="" className="absolute inset-0 w-full h-full object-cover opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950 via-primary-950/85 to-transparent" />

        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-16 sm:py-20 md:py-24">
          <div className="max-w-2xl">
            <span className="text-xs font-semibold uppercase tracking-[0.14em] text-gold-400 mb-4 block">Sky View GmbH</span>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-serif font-medium text-white mb-6 leading-tight">
              Impressum
            </h1>
            <div className="w-16 h-[3px] bg-gold-500 mb-6"></div>
            <p className="text-base sm:text-lg text-primary-200 leading-relaxed">
              Angaben gemäß § 5 TMG und § 2 DL-InfoV.
            </p>
          </div>
        </div>
      </div>

      {/* Three Cards Section */}
      <div className="bg-white py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
              {/* Card 1 - Anschrift */}
              <div className="bg-white border border-slate-200 border-t-2 border-t-gold-500 p-6 sm:p-8">
                <div className="w-11 h-11 bg-primary-50 flex items-center justify-center mb-6">
                  <MapPin className="w-5 h-5 text-primary-700" />
                </div>
                <h3 className="text-lg font-serif font-medium text-slate-900 mb-3">Anschrift</h3>
                <p className="text-slate-600 text-sm leading-relaxed">
                  Sky View GmbH<br/>
                  Bockenheimer Landstraße 17/19<br/>
                  60325 Frankfurt am Main<br/>
                  Deutschland
                </p>
                <p className="text-slate-600 text-sm leading-relaxed mt-3">
                  E-Mail: <a href="mailto:info@skyview-assets.de" className="text-primary-700 hover:text-gold-600 transition-colors">info@skyview-assets.de</a>
                </p>
              </div>

              {/* Card 2 - Vertretungsberechtigte */}
              <div className="bg-white border border-slate-200 border-t-2 border-t-gold-500 p-6 sm:p-8">
                <div className="w-11 h-11 bg-primary-50 flex items-center justify-center mb-6">
                  <Building className="w-5 h-5 text-primary-700" />
                </div>
                <h3 className="text-lg font-serif font-medium text-slate-900 mb-3">Vertretungsberechtigte</h3>
                <p className="text-slate-600 text-sm leading-relaxed">
                  Geschäftsführung:<br/>
                  Benjamin Winter<br/>
                  Dr. Anna Schmidt
                </p>
              </div>

              {/* Card 3 - Registrierung */}
              <div className="bg-white border border-slate-200 border-t-2 border-t-gold-500 p-6 sm:p-8">
                <div className="w-11 h-11 bg-gold-50 flex items-center justify-center mb-6">
                  <FileText className="w-5 h-5 text-gold-700" />
                </div>
                <h3 className="text-lg font-serif font-medium text-slate-900 mb-3">Registrierung</h3>
                <p className="text-slate-600 text-sm leading-relaxed">
                  Registrierte AIF-Kapitalverwaltungsgesellschaft<br/>
                  gemäß § 44 KAGB<br/>
                  BaFin-ID: 10155391 · BaK-Nr.: 155391
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* BaFin-Prüfung */}
      <div className="bg-primary-50/40 py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white border border-slate-200 border-t-[3px] border-t-primary-600 p-6 sm:p-10">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-11 h-11 bg-primary-50 flex items-center justify-center shrink-0">
                  <Shield className="w-5 h-5 text-primary-700" />
                </div>
                <div>
                  <h2 className="text-xl font-serif font-medium text-slate-900 mb-2">
                    Aufsichtsrechtliche Registrierung
                  </h2>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    Sky View GmbH ist als Kapitalverwaltungsgesellschaft gemäß § 44 KAGB bei der
                    Bundesanstalt für Finanzdienstleistungsaufsicht (BaFin) registriert. Der
                    Registereintrag kann öffentlich im BaFin-Unternehmensregister eingesehen werden.
                  </p>
                </div>
              </div>

              <a
                href={BAFIN_REGISTER_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-between gap-4 bg-primary-950 border-l-4 border-gold-500 px-6 py-5 hover:bg-primary-900 transition-colors group"
              >
                <div>
                  <div className="text-xs font-semibold uppercase tracking-[0.1em] text-gold-400 mb-1">
                    BaFin-Unternehmensregister
                  </div>
                  <div className="text-white text-sm font-medium">
                    BaFin-ID 10155391 · BaK-Nr. 155391
                  </div>
                </div>
                <ExternalLink className="w-5 h-5 text-primary-300 group-hover:text-gold-400 transition-colors shrink-0" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Two Cards - Haftungsausschluss / Externe Links */}
      <div className="bg-white py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-5">
            <div className="bg-white border border-slate-200 border-t-2 border-t-primary-600 p-6 sm:p-8">
              <h3 className="text-lg font-serif font-medium text-slate-900 mb-3">Haftungsausschluss</h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                Die Inhalte dieser Website wurden mit größtmöglicher Sorgfalt erstellt. Für die
                Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine
                Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene
                Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
              </p>
            </div>
            <div className="bg-white border border-slate-200 border-t-2 border-t-gold-500 p-6 sm:p-8">
              <h3 className="text-lg font-serif font-medium text-slate-900 mb-3">Externe Links</h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                Unsere Website enthält Links zu externen Websites Dritter, auf deren Inhalte wir
                keinen Einfluss haben. Für diese fremden Inhalte übernehmen wir daher keine Gewähr.
                Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter verantwortlich.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Urheberrechte CTA strip */}
      <div className="bg-primary-50/40 pb-16 md:pb-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="relative overflow-hidden bg-primary-950 border-l-4 border-gold-500 px-8 py-12 md:px-14 text-center">
              <h3 className="text-2xl font-serif font-medium text-white mb-3">Urheberrechte</h3>
              <p className="text-primary-200 leading-relaxed max-w-xl mx-auto">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
                unterliegen dem deutschen Urheberrecht. Vervielfältigung, Bearbeitung, Verbreitung
                und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
                schriftlichen Zustimmung von Sky View GmbH.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Three Column Details */}
      <div className="bg-white py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
            <div>
              <h4 className="text-sm font-semibold uppercase tracking-wider text-primary-700 mb-3">
                Aufsichtsbehörde
              </h4>
              <p className="text-slate-600 text-sm leading-relaxed">
                Bundesanstalt für Finanzdienstleistungsaufsicht (BaFin)<br/>
                Graurheindorfer Straße 108, 53117 Bonn<br/>
                Marie-Curie-Straße 24–28, 60439 Frankfurt am Main<br/>
                <a href="https://www.bafin.de" target="_blank" rel="noopener noreferrer" className="text-primary-700 hover:text-gold-600 transition-colors">
                  www.bafin.de
                </a>
              </p>
            </div>
            <div>
              <h4 className="text-sm font-semibold uppercase tracking-wider text-primary-700 mb-3">
                Berufsbezeichnung
              </h4>
              <p className="text-slate-600 text-sm leading-relaxed">
                Registrierte AIF-Kapitalverwaltungsgesellschaft gemäß § 44 KAGB, verliehen in der
                Bundesrepublik Deutschland.
              </p>
            </div>
            <div>
              <h4 className="text-sm font-semibold uppercase tracking-wider text-primary-700 mb-3">
                Streitschlichtung
              </h4>
              <p className="text-slate-600 text-sm leading-relaxed">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Rechtliche Sicherheit */}
      <div className="bg-primary-50/40 py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <span className="text-xs font-semibold uppercase tracking-[0.14em] text-primary-600 mb-3 block">Vertrauen &amp; Transparenz</span>
            <h2 className="text-2xl md:text-3xl font-serif font-medium text-slate-900 mb-4">
              Rechtliche Sicherheit für unsere Kunden
            </h2>
            <p className="text-slate-600 leading-relaxed max-w-2xl mx-auto">
              Als registrierte Kapitalverwaltungsgesellschaft unterliegt Sky View GmbH der
              laufenden Aufsicht durch die BaFin. Wir legen Wert auf volle Transparenz gegenüber
              unseren Kunden – über unsere rechtlichen Rahmenbedingungen ebenso wie über unsere
              Anlagestrategien.
            </p>
          </div>
        </div>
      </div>
    </PublicShell>
  );
};

export default ImpressumPage;
